import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../lib/adminAPI';
import { Users, ArrowDownToLine, ArrowUpToLine, ShieldCheck, Activity, DollarSign, TrendingUp, Clock } from 'lucide-react';

const Card = ({ label, value, icon: Ico, sub, color = '#00e676' }) => (
  <div className="p-5 rounded-xl border border-[#1a2823] bg-[#0a1210]">
    <div className="flex items-center justify-between mb-3">
      <span className="text-xs text-gray-400 uppercase tracking-wider">{label}</span>
      <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: `${color}1a`, border: `1px solid ${color}33`, color }}>
        <Ico size={14}/>
      </div>
    </div>
    <div className="text-2xl font-extrabold text-white mono">{value}</div>
    {sub && <div className="mt-1 text-xs text-gray-400">{sub}</div>}
  </div>
);

const AdminOverview = () => {
  const [s, setS] = useState(null);
  useEffect(() => { adminAPI.stats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="text-sm text-gray-500">Loading…</div>;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Admin Overview</h1>
        <p className="text-sm text-gray-400">Platform-wide activity, deposits, withdrawals, and verifications.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card label="Total Users" value={s.total_users} icon={Users} sub={`${s.verified_users} verified`}/>
        <Card label="Pending KYC" value={s.pending_kyc} icon={ShieldCheck} color="#eab308" sub="Awaiting review"/>
        <Card label="Pending Deposits" value={s.pending_deposits ?? 0} icon={ArrowDownToLine} color="#eab308" sub="Awaiting proof review"/>
        <Card label="Pending Withdrawals" value={s.pending_withdrawals} icon={Clock} color="#eab308" sub="Requires approval"/>
        <Card label="Open Positions" value={s.open_positions} icon={Activity} color="#0ea5e9" sub="Across all users"/>
        <Card label="Deposit Volume" value={`$${(s.deposit_volume || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} icon={ArrowDownToLine}/>
        <Card label="Withdraw Volume" value={`$${(s.withdraw_volume || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} icon={ArrowUpToLine} color="#ef4444"/>
        <Card label="Net Deposits" value={`$${(s.net_deposits || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} icon={DollarSign} color={s.net_deposits >= 0 ? '#00e676' : '#ef4444'}/>
        <Card label="Verification Rate" value={s.total_users ? `${((s.verified_users / s.total_users) * 100).toFixed(0)}%` : '0%'} icon={TrendingUp}/>
      </div>
    </div>
  );
};

export default AdminOverview;
